import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@api";
import LeaderboardSettings from "../SystemPageSettings/LeaderboardSettings.jsx";
import ScheduleSettings from "../SystemPageSettings/ScheduleSettings.jsx";
import StandingSettings from "../SystemPageSettings/StandingSettings.jsx";
import TournamentBracketSettings from "../SystemPageSettings/TournamentBracketSettings.jsx";

function SystemPageSettings() {
 const { id, pageId } = useParams();
 const [page, setPage] = useState(null);
 const [loading, setLoading] = useState(true);


 useEffect(() => {
  let alive = true;

  const loadPage = async () => {
   try {
    const res = await api.get(`/api/organization-page/${id}`);
    if (!alive) return;

    const pages = res.data?.pages || [];
    console.log(pages)
    const organization = res.data?.organization || null;
    const foundPage = pages.find((p) => String(p.id) === String(pageId));

    setPage(foundPage ? { ...foundPage, organization } : null);
   } catch (err) {
    console.error("Failed to load system page settings:", err);
    if (!alive) return;
    setPage(null);
   } finally {
    if (alive) setLoading(false);
   }
  };

  loadPage();

  return () => {
   alive = false;
  };
 }, [id, pageId]);



 if (loading) return <div style={{ padding: "2rem" }}>Loading...</div>;

 if (!page) {
  return (
   <div style={{ padding: "2rem" }}>
    <h1>System Page Settings</h1>
    <p>Page not found.</p>
    <p>Organization ID: {id}</p>
    <p>Page ID: {pageId}</p>
   </div>
  );
 }

 return (

  <div style={{ padding: "2rem" }}>
   {/* <h1>System Page Settings</h1>
   <p>Page not found.</p>
   <p>Organization ID: {id}</p>
   <p>Page ID: {pageId}</p> */}
   {page?.system_key === "leaderboard" && (
    <LeaderboardSettings id={id} pageId={pageId} page={page} />
   )}
   {page?.system_key === "schedule" && (
    <ScheduleSettings id={id} pageId={pageId} page={page} />
   )}
   {page?.system_key === "standings" && (
    <StandingSettings id={id} pageId={pageId} page={page} />
   )}
   {page?.system_key === "tournament_bracket" && (
    <TournamentBracketSettings
     id={id}
     pageId={pageId}
     page={page}
    />
   )}
  </div>
 );
}

export default SystemPageSettings;